import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

import { useAccount } from "#/store/wallet/account/account";

export const showWelcomeModalStateAtom = atomWithStorage<{
  [account: string]: boolean;
}>("showWelcomeModalState", {});

export const useShowWelcomeModal = () => {
  const { account } = useAccount();
  const [showWelcomeModalState, setShowWelcomeModalState] = useAtom(
    showWelcomeModalStateAtom,
  );
  const showWelcomeModal = account
    ? (showWelcomeModalState[account] ?? true)
    : false;

  return {
    showWelcomeModal,
    setShowWelcomeModal: (value: boolean) => {
      if (!account) return;

      setShowWelcomeModalState((prevState) => ({
        ...prevState,
        [account]: value,
      }));
    },
  };
};
